import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { Moment } from 'moment';
import * as moment from 'moment';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MY_DATE_FORMATS } from 'src/app/shared/validators/mat-date-formatter';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MatDialog } from '@angular/material/dialog';
import { ReportModalDialogComponent } from '../report-modal-dialog/report-modal-dialog.component';
import { NotificationService } from 'src/app/services/notification-service';

@Component({
    selector: 'app-recurring-invoice',
    templateUrl: './recurring-invoice.component.html',
    styleUrls: ['./recurring-invoice.component.scss'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },

        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    ],
})
export class RecurringInvoiceComponent implements OnInit {

    RecInvReport: FormGroup;
    maxDate: Date;
    minDate: Date;
    @ViewChild('startDate') startDatePicker: MatDatepicker<Date>;
    @ViewChild('approveDate') approveDatePicker: MatDatepicker<Date>;
    date = new FormControl(moment());

    constructor(private fb: FormBuilder, private dialog: MatDialog, private toastr: NotificationService) { }

    ngOnInit(): void {
        var maxDates = new Date();
        maxDates.setMonth(maxDates.getMonth() + 1);
        this.maxDate = new Date(maxDates.getFullYear(), maxDates.getMonth(), maxDates.getDate())

        var minDates = new Date();
        minDates.setMonth(minDates.getMonth() - 1);
        this.minDate = new Date(minDates.getFullYear(), minDates.getMonth(), 1)
        this.initializeValidators();
    }

    initializeValidators() {
        this.RecInvReport = this.fb.group({
            startDate: [this.maxDate, Validators.required],
            approveDate: ['', Validators.required],
        });
    }

    refresh() {
        this.RecInvReport.reset();
        this.RecInvReport.controls['startDate'].setValue(this.maxDate);
    }

    FnstartDatePicker() {
        this.startDatePicker.open();
    }

    FnApproveDatePicker() {
        this.approveDatePicker.open();
    }

    setMonthAndYear(normalizedMonthAndYear: Moment, datepicker: MatDatepicker<Moment>) {
        const ctrlValue = this.date.value ?? moment();
        ctrlValue.month(normalizedMonthAndYear.month());
        ctrlValue.year(normalizedMonthAndYear.year());
        this.RecInvReport.controls['startDate'].setValue(ctrlValue);
        datepicker.close();
    }

    setApproveMonthAndYear(normalizedMonthAndYear: Moment, datepicker: MatDatepicker<Moment>) {
        const ctrlValue = this.date.value ?? moment();
        ctrlValue.month(normalizedMonthAndYear.month());
        ctrlValue.year(normalizedMonthAndYear.year());
        this.RecInvReport.controls['approveDate'].setValue(ctrlValue);
        datepicker.close();
    }

    Report() {
        let formValues = this.RecInvReport.getRawValue();
        let startValue = moment(formValues.startDate).format('YYYY/MM/DD');
        this.dialog.open(ReportModalDialogComponent, {
            autoFocus: false,
            disableClose: true,
            panelClass: 'mat-dialog',
            width: "550px",
            data: {
                displayPanel: 'SendOverEmail',
                startDate: startValue,
                reportType: 3
            }
        });
    }

    SubmitMWRecInv() {
        if (this.RecInvReport.get('approveDate').invalid) {
            this.toastr.showWarning("Recurring Billing Month should not be empty")
        } else {
            let formValues = this.RecInvReport.getRawValue();
            let startValue = moment(formValues.startDate).format('YYYY/MM/DD');
            this.dialog.open(ReportModalDialogComponent, {
                autoFocus: false,
                disableClose: true,
                panelClass: 'mat-dialog',
                width: "550px",
                data: {
                    displayPanel: 'MWRecInvoice',
                    startDate: startValue,
                }
            });
        }
    }

}
